import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  
  // Activate loading overlay
  loaderService.show();
  
  return next(req).pipe(
    finalize(() => {
      // Deactivate loading overlay when request finishes or errors out
      loaderService.hide();
    })
  );
};
